export const NEO_SMARTPEN_TYPE = {
    NETWORK_PEN: { type: "network", local: false },
    REAL_PEN: { type: "real", local: true },
    MOUSE_PEN: { type: "mouse", local: true },
    STYLUS_PEN: { type: "stylus", local: true },
    FINGER_PEN: { type: "finger", local: true },
    SDK_PEN: { type: "from_sdk", local: true },
    INKSTORE_PEN: { type: "real", local: false },
    TESTING: { type: "test", local: true },
    MENU_ACTION: { type: "menu", local: true },
    OFFLINE_DATA: { type: "real", local: true },
};
//# sourceMappingURL=INeoSmartpen.js.map